import axios from "axios";
import { getDefaultConfigHeader } from "../../Utils/headerDefaultConfigPetition";

const url = process.env.REACT_APP_API_BACKEND + "/rol";

// [{ id, name, employees_count, permissions_count }]
export const getRoles = () => axios.get(url, getDefaultConfigHeader());

// { id, name, employees_count, permissions: [...] }
export const getRole = (id: number) => axios.get(`${url}/${id}`, getDefaultConfigHeader());

export const addRole = (role: { name: string; permission_ids?: number[] }) =>
  axios.post(url, role, getDefaultConfigHeader());

// permission_ids es la lista completa y reemplaza a la anterior
export const updateRole = (id: number, changes: { name?: string; permission_ids?: number[] }) =>
  axios.put(`${url}/${id}`, changes, getDefaultConfigHeader());

export const deleteRole = (id: number) => axios.delete(`${url}/${id}`, getDefaultConfigHeader());
